/**
 * Retrieves the value of a specified URL parameter.
 * @param {string} name - The name of the URL parameter to retrieve.
 * @return {string | null} - The value of the URL parameter, or null if not found.
 */
export function getURLParameter(name: string): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
}
